export function Footer() {
  return (
    <footer className="border-t border-slate-800 py-6 text-center font-mono text-xs text-slate-600">
      © CLASSFIRE Project Share
    </footer>
  );
}
